module.exports = __webpack_public_path__ + "img/drag1.89a1cc98.svg";